import { campaignRoute, homeRoute, profileRoute } from "@/routes";

import { campaignNavItems } from "@/utils/route-helpers";
import { useCampaign } from "./use-campaign";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface HeaderNavigation {
  segments: string[];
  backTo: string | null;
}

export const useHeaderNavigation = (): HeaderNavigation => {
  const location = useLocation();
  const { t } = useTranslation();
  const { campaignData } = useCampaign();
  const { pathname } = location;

  if (pathname === homeRoute) {
    return { segments: [t("general.homeTitle")], backTo: null };
  }

  if (pathname === profileRoute) {
    return { segments: [t("general.profile")], backTo: homeRoute };
  }

  if (pathname.startsWith("/campaign")) {
    const campaignName = campaignData?.name ?? t("campaign.defaultName");

    if (pathname === campaignRoute || pathname === "/campaign/overview") {
      return { segments: [campaignName], backTo: homeRoute };
    }

    const navItem = campaignNavItems.find((item) => item.path === pathname);
    const subLabel = navItem
      ? t(navItem.labelKey)
      : (pathname.split("/").pop() ?? "");

    return {
      segments: [campaignName, subLabel],
      backTo: campaignRoute,
    };
  }

  return { segments: [], backTo: homeRoute };
};
